import {axios} from "./config"
export class Dashboard extends axios{
   axios;
   token;
   constructor(){
   super();
   this.axios=this.axiosConfig();
 }
 async statistics(data){
        try{
        let result=await this.axios({
        method:"post",
        url:"systemcount/searchByDate",
        data
    });
        return new Promise((res,rej)=>{
            res(result.data);
        })
        }catch(e){
            return new Promise((res,rej)=>{
                rej(e);
            })
          
        }
          }
          async timeIntervalData(data){
            try{
            let result=await this.axios({
            method:"post",
            url:"systemcount/hourlyWise",
            data
        });
            return new Promise((res,rej)=>{
                res(result.data);
            })
            }catch(e){
                return new Promise((res,rej)=>{
                    rej(e);
                })
              
            }
              }
        
}